import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ClientUserEntity } from './client-user-base.model';

@Injectable({
  providedIn: 'root'
})
export class ClientUserBaseApi {
  constructor(private _http: HttpClient) { }

  entity$(id: string) {
    return this._http.get<ClientUserEntity>(
      `/api/public/client-user/${id}`
    );
    /**
     * Mocked update as a pre-paid client for specified clients.
     */
    /*
    .pipe(
      map((clientUserEntity) => {
        const clientId = clientUserEntity.client.id;
        if (clientId === 'vLAutRnLQraNhrYDXvSLAi') {
          const client = clientUserEntity.client;
          const clientUpdated = { ...client, ...{ mode: ClientMode.PRE_PAID, type: ClientType.LEGAL_ENTITY } };
          return { ...clientUserEntity, ...{ client: clientUpdated } };
        } else {
          const client = clientUserEntity.client;
          const clientUpdated = { ...client, ...{ mode: ClientMode.POST_PAID, type: ClientType.LEGAL_ENTITY } };
          return { ...clientUserEntity, ...{ client: clientUpdated } };
        }
      })
    );
    */
  }

  list$(clientId: string) {
    return this._http.get<{ clientUserList: ClientUserEntity[] }>(
      `/api/public/client/${clientId}/user`
    );
    /**
     * Mocked update as a pre-paid client for specified clients.
     */
    /*
    .pipe(
      map((d) => ({
        clientUserList: d.clientUserList.map((clientUserEntity) => {
          const clientId = clientUserEntity.client.id;
          if (clientId === 'vLAutRnLQraNhrYDXvSLAi') {
            const client = clientUserEntity.client;
            const clientUpdated = { ...client, ...{ mode: ClientMode.PRE_PAID, type: ClientType.LEGAL_ENTITY } };
            return { ...clientUserEntity, ...{ client: clientUpdated } };
          } else {
            const client = clientUserEntity.client;
            const clientUpdated = { ...client, ...{ mode: ClientMode.POST_PAID, type: ClientType.LEGAL_ENTITY } };
            return { ...clientUserEntity, ...{ client: clientUpdated } };
          }
        })
      }))
    );
    */
  }

}
